// frontend/src/components/FinanceReport/Accounting/our_allocations/supplier_prepayments/requests.js
import { authFetch } from "../../../../api/api";


const BASE_URL = (process.env.REACT_APP_DJANGO_BACKEND || "").replace(/\/+$/, "");
const SUPPLIER_PREPAYMENTS_URL = `${BASE_URL}/api/accounting/supplier-prepayments/`;

// ⚠️ Обрати внимание: /api/suppliers/suppliers/ — двойной suppliers,
// потому что myproject/urls.py делает path("api/suppliers/", include(...)),
// а apps/suppliers/urls.py — router.register(r"suppliers", SupplierViewSet).
const SUPPLIERS_URL = `${BASE_URL}/api/suppliers/suppliers/`;

// ----------------------------------------------------------------------
// 1. GET — список предоплат по allocation
// ----------------------------------------------------------------------
export async function getAllSupplierPrepayments(allocationId) {
  const url = allocationId
    ? `${SUPPLIER_PREPAYMENTS_URL}?allocation=${allocationId}`
    : SUPPLIER_PREPAYMENTS_URL;

  const response = await authFetch(url);
  if (!response.ok) {
    throw new Error(`HTTP ${response.status}: ${response.statusText}`);
  }
  const data = await response.json();
  return Array.isArray(data) ? data : data.results || [];
}

// ----------------------------------------------------------------------
// 2. GET — один по id
// ----------------------------------------------------------------------
export async function getOneSupplierPrepayment(id) {
  const response = await authFetch(`${SUPPLIER_PREPAYMENTS_URL}${id}/`);
  if (!response.ok) {
    throw new Error(`HTTP ${response.status}: ${response.statusText}`);
  }
  return response.json();
}

// ----------------------------------------------------------------------
// 3. POST — создать
// ----------------------------------------------------------------------
export async function postSupplierPrepayment(payload) {
  const response = await authFetch(SUPPLIER_PREPAYMENTS_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(`HTTP ${response.status}: ${JSON.stringify(err)}`);
  }
  return response.json();
}

// ----------------------------------------------------------------------
// 4. PATCH — частично обновить
// ----------------------------------------------------------------------
export async function patchSupplierPrepayment(id, patch) {
  const response = await authFetch(`${SUPPLIER_PREPAYMENTS_URL}${id}/`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(patch),
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(`HTTP ${response.status}: ${JSON.stringify(err)}`);
  }
  return response.json();
}

// ----------------------------------------------------------------------
// 5. DELETE — удалить
// ----------------------------------------------------------------------
export async function deleteSupplierPrepayment(id) {
  const response = await authFetch(`${SUPPLIER_PREPAYMENTS_URL}${id}/`, {
    method: "DELETE",
  });
  if (!response.ok) {
    throw new Error(`HTTP ${response.status}: ${response.statusText}`);
  }
  return { ok: true, status: response.status };
}

// ----------------------------------------------------------------------
// 6. Документы — загрузка
// ----------------------------------------------------------------------
export async function uploadSupplierPrepaymentDocument(prepaymentId, file) {
  const fd = new FormData();
  fd.append("files", file);

  const response = await authFetch(
    `${SUPPLIER_PREPAYMENTS_URL}${prepaymentId}/documents/`,
    { method: "POST", body: fd }
  );
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(`HTTP ${response.status}: ${JSON.stringify(err)}`);
  }
  return response.json();
}

// ----------------------------------------------------------------------
// 7. Документы — удаление
// ----------------------------------------------------------------------
export async function deleteSupplierPrepaymentDocument(documentId) {
  const response = await authFetch(
    `${BASE_URL}/api/accounting/supplier-prepayment-documents/${documentId}/`,
    { method: "DELETE" }
  );
  if (!response.ok) {
    throw new Error(`HTTP ${response.status}: ${response.statusText}`);
  }
  return { ok: true, status: response.status };
}

// ----------------------------------------------------------------------
// 8. Список поставщиков (для выпадающего списка)
// ----------------------------------------------------------------------
export async function getAllSuppliers() {
  const response = await authFetch(SUPPLIERS_URL);
  if (!response.ok) {
    throw new Error(`HTTP ${response.status}: ${response.statusText}`);
  }
  const data = await response.json();
  return Array.isArray(data) ? data : data.results || [];
}